<template>
  <div class="chooseType">
    <div class="schedule q-mx-lg">
      <div class="text">{{ $t('home.scheduleTitle') }}</div>
      <q-btn no-caps class="full-width" unelevated @click="dialog = true">
        <slot name="btn">
          <img :src="icons.schedule" alt="" srcset="" />
          {{ $t('home.scheduleBtn') }}
          <span class="iconfont right-icon">&#xe744;</span>
        </slot>
      </q-btn>
    </div>
    <q-dialog v-model="dialog" position="bottom">
      <q-card class="no-border-radius">
        <q-card-section class="q-py-none">
          <q-banner dense inline-actions class="q-px-none q-py-sm q-my-xs">
            <span class="font-size-14 text-weight-bolder">
              {{ $t('home.scheduleTypeTitle') }}
            </span>
            <template #action>
              <q-btn v-close-popup size="xs" unelevated round flat>
                <q-icon size="16px" name="font:dm-close" />
              </q-btn>
            </template>
          </q-banner>
        </q-card-section>
        <q-card-section class="q-py-none q-mb-md">
          <q-item
            v-if="scheduled && scheduled.scheduledDelivery"
            class="no-padding"
            tag="label"
          >
            <q-item-section class="no-margin">
              <q-item-label @click="goList('DELIVERY')">
                <q-avatar size="32px">
                  <img src="~assets/images/delivery.svg" />
                </q-avatar>
                <span
                  class="q-ml-xs vertical-middle font-size-14 text-black text-weight-bold"
                >
                  {{ $t('home.deliverySchedule') }}
                </span>
                <q-icon
                  size="20px"
                  class="float-right text-theme-gray q-mt-xs"
                  name="font:dm-right"
                />
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item
            v-if="scheduled && scheduled.scheduledPickUp"
            class="no-padding"
            tag="label"
          >
            <q-item-section class="no-margin">
              <q-item-label @click="goList('PICK_UP')">
                <q-avatar size="32px">
                  <img src="~assets/images/pickup.svg" />
                </q-avatar>
                <span
                  class="q-ml-xs vertical-middle font-size-14 text-black text-weight-bold"
                >
                  {{ $t('home.pickupSchedule') }}
                </span>
                <q-icon
                  size="20px"
                  class="float-right text-theme-gray q-mt-xs"
                  name="font:dm-right"
                />
              </q-item-label>
            </q-item-section>
          </q-item>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    icons: {
      type: Object,
      default: () => ({
        schedule:
          'https://static.bakmigm.co.id/menu/6329a03b14327c63d9d5ee372b54ef66.png',
      }),
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      name: '',
      locale: '',
      options: [
        { label: 'Indonesia', value: 'id-ID' },
        { label: 'English', value: 'en-US' },
      ],
    };
  },
  computed: {
    ...mapState({
      scheduled: (state) => state.prefetch.storeInfo.scheduled,
      nearestStatus: (state) => state.Menu.nearestStatus,
    }),
  },
  watch: {
    language(val) {
      this.locale = val;
      const curr = this.options.filter((item) => item.value === this.locale);
      this.name = curr[0].label;
    },
  },
  methods: {
    settingLanguage() {
      this.$store.commit('Menu/updateLanguage', this.locale);
      this.$i18n.locale = this.locale;
    },
    flag(val) {
      return this.locale === val ? 'font:dm-radio-active' : 'font:dm-radio';
    },
    goList(type) {
      if (type === 'DELIVERY') {
        if (this.info && this.info.chainStore && !this.nearestStatus) {
          this.$store.commit('Menu/updateAccessStatus', type);
          this.$store.commit('Menu/updateScheduled', true);
          this.$emit('showNearest');
        } else {
          this.handleGoList(type);
        }
      } else {
        this.handleGoList(type);
      }
    },
    handleGoList(type) {
      const url = this.$route.params.store;
      this.$store.commit('Menu/updateAccessStatus', type);
      this.$store.commit('Menu/updateScheduled', true);
      this.$router.push(`/${url}/products-list`);
    },
  },
};
</script>

<style lang="scss" scoped>
.chooseType {
  .schedule {
    padding-top: 30px;
    .text {
      margin-bottom: 10px;
      line-height: 18px;
    }
    .q-btn {
      background: #ffffff;
      color: $black;
      width: 100%;
      border-radius: 8px;
      font-weight: bold;
      font-size: 14px;
      line-height: 18px;
      padding: 6px 0;
      position: relative;
      // .scheduleBtnIcon {
      //   font-size: 22px;
      //   color: $primary;
      //   padding: 2px;
      //   background: $primary02;
      //   width: 26px;
      //   height: 26px;
      //   border-radius: 50%;
      //   line-height: 1;
      //   margin-right: 10px;
      // }
      img {
        width: 24px;
        margin-right: 6px;
      }
      .right-icon {
        display: block;
        position: absolute;
        right: 18px;
        font-size: 22px;
        color: $primary;
      }
    }
  }
}
</style>
